import { render } from "./BasicForm.vue?vue&type=template&id=6dd18fd8"
import script from "./BasicForm.vue?vue&type=script&lang=js"
export * from "./BasicForm.vue?vue&type=script&lang=js"
script.render = render

export default script